// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3i__i","info":"Note_info__B0rcz","note":"Note_note__1fDyL","actions":"Note_actions__1cgru"};